import {
  getRegion, getBrowserSystemLanguage, getHostUrl, getLanguage,
} from '@m2h/common/utils';

const module = {
  getRegionInfo() {
    return {
      store_country: getRegion(),
      app_language: getBrowserSystemLanguage(),
      sim_region: getRegion(),
      locale_language: getLanguage(),
      locale_country: getRegion(),
    };
  },
};

export default module;
